export default {
  actions: {
    id: 'bo_sellers-orders-components-orders_table-actions',
    defaultMessage: 'Actions',
  },
  moreDetails: {
    id: 'bo_sellers-orders-components-orders_table-more_details',
    defaultMessage: 'More details',
  },
  contactCustomer: {
    id: 'bo_sellers-orders-components-orders_table-actions-contact_customer',
    defaultMessage: 'Contact customer',
  },
  cancelOrder: {
    id: 'bo_sellers-orders-components-orders_table-actions-cancel_order',
    defaultMessage: 'Cancel order',
  },
  cancelOrderLine: {
    id: 'bo_sellers-orders-components-orders_table-actions-cancel_order_line',
    defaultMessage: 'Cancel orderline {orderLineId}',
  },
  refundOrder: {
    id: 'bo_sellers-orders-components-orders_table-actions-refund_order',
    defaultMessage: 'Refund order',
  },
  refundOrderLine: {
    id: 'bo_sellers-orders-components-orders_table-actions-refund_order_line',
    defaultMessage: 'Refund orderline {orderLineId}',
  },
  fixOrderIssue: {
    id: 'bo_seller.orders.components.orders_table.actions.fix_order_issue',
    defaultMessage: 'Fix order issue',
  },
}
